import { useAppSelector } from '../hooks';
import { type RootState } from '../store';
import { type ISolution, selectSolutionDrafts } from '../reducers/solutionsSlice';

export const useSolutionDrafts = (): { solutionDrafts: ISolution[] } => {
  const solutionDrafts = useAppSelector((state: RootState) => selectSolutionDrafts(state));

  return { solutionDrafts };
};
